"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _contentful = require("contentful");
var space = process.env.CONTENTFUL_SPACE_ID;
var accessToken = process.env.CONTENTFUL_DELIVERY_ACCESS_TOKEN;
var previewAccessToken = process.env.CONTENTFUL_PREVIEW_ACCESS_TOKEN;
var environment = process.env.CONTENTFUL_ENVIRONMENT;

/**
 * Initialises a Contentful client
 *
 * @param {object} [config] - Configuration for getClient
 * @param {boolean} [config.preview] - Flag to use the preview API
 * @returns {ContentfulClientAPI.ClientAPI} - Contentful client
 * @example
 * import { getClient } from '@sh24/contentful-service'
 * const contentful = getClient()
 */
var getClient = function getClient(_ref) {
  var preview = _ref.preview,
    requestLogger = _ref.requestLogger,
    responseLogger = _ref.responseLogger;
  return (0, _contentful.createClient)({
    space: space,
    accessToken: preview ? previewAccessToken : accessToken,
    host: preview ? 'preview.contentful.com' : 'cdn.contentful.com',
    environment: environment,
    requestLogger: requestLogger,
    responseLogger: responseLogger,
    removeUnresolved: true
  });
};
var _default = getClient;
exports["default"] = _default;